export function parseLanguageCountryCode(languageCode: string, countryCode: string): string {
  return `${languageCode}-${countryCode}`;
}
